import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { SystemApi } from "features/brm";

/**
 * Sets the name of an Datatype
 *
 * @param {string} dataTypeId - uuid of the dataType
 * @param {string} name - new name of the dataType
 */
export const setDataTypeName = ({ dataTypeId, name }) => {
  return Brm.dataTypeApi.setDataTypeName(dataTypeId, { body: name });
};

/**
 * Custom hook to change the name of an existing datatype
 *
 * @param {string} projectId - uuid of the project
 * @param {object} config - react-query configuration object
 * @returns react-query ReactQuery.useMutation
 */
export const useSetDataTypeName = ({ projectId, config = {} } = {}) => {
  const queryClient = ReactQuery.useQueryClient();

  return ReactQuery.useMutation({
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(SystemApi.dataTypeKeys.project(projectId));
      queryClient.invalidateQueries(SystemApi.dataTypeKeys.dataType(variables.dataTypeId));
    },
    ...config,
    mutationFn: setDataTypeName,
  });
};
